                import React, { useState, useEffect } from 'react';

                const RevolvingWords = ({ words, interval = 2000 }) => {
                const [index, setIndex] = useState(0);

                useEffect(() => {
                    const id = setInterval(() => {
                    setIndex((prev) => (prev + 1) % words.length);
                    }, interval);
                    return () => clearInterval(id);
                }, [words, interval]);

                return (
                    <span
                    style={{
                        display: 'inline-block',
                        position: 'relative',
                        minWidth: '11ch', // enough space for longest word
                        height: '1.2em', // fixes line height to prevent jump
                    }}
                    >
                    {words.map((word, i) => (
                        <span
                        key={i}
                        style={{
                            position: 'absolute',
                            fontStyle: 'italic',
                            top: 0,
                            left: 0,
                            opacity: i === index ? 1 : 0,
                            transition: 'opacity 0.3s ease-in-out',
                            whiteSpace: 'nowrap',
                        }}
                        >
                        {word}
                        </span>
                    ))}
                    </span>
                );
                };

                export default RevolvingWords;
